import moment from "moment";

export const ConvertTime = (date) => {
  return moment(date).format("ll");
};

export function Number(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
